import type { JSX } from "react";

import framnaSymbolWhiteUrl from "../../framna-agent-brand-kit/assets/symbol/RGB/SVG/Framna_Symbol_RGB_White.svg";
import framnaWordmarkWhiteUrl from "../../framna-agent-brand-kit/assets/logo/RGB/SVG/Framna_Logo_RGB_White.svg";

type FramnaBidLogoIconProps = {
  className?: string;
};

type FramnaWordmarkProps = {
  className?: string;
};

export const FramnaBidLogoIcon = ({ className }: FramnaBidLogoIconProps): JSX.Element => {
  return <img src={framnaSymbolWhiteUrl} alt="" aria-hidden="true" className={className} />;
};

export const FramnaWordmark = ({ className }: FramnaWordmarkProps): JSX.Element => {
  return <img src={framnaWordmarkWhiteUrl} alt="Framna" className={className} />;
};
